import Helper from './Helper';

class Link {
  constructor(config = {}) {
    const {
      linksSelector,
    } = config;
    this.links = document.querySelectorAll(linksSelector);
    this.linksArray = Array.prototype.slice.call(this.links);
    if(this.links){
      this.addTargetBlank();
    }
  }

  addTargetBlank(){
    this.linksArray.forEach((link, i) => {
      if(link.tagName == 'A'){
        link.setAttribute('target', '_blank');
      } else {
        link.querySelector('a').setAttribute('target', '_blank');
      }
    });
  }

}

export default Link;
